import { defineStore } from "pinia";
import config from '@shared/config/config'; // main 폴더 스타일 경로
import { getCookieObject, setCookieObject } from '@/shared/utils/cookieHelper';

// 쿠키 키 이름
const CUSTOMIZER_COOKIE_KEY = 'lettaga_customizer_settings';

// 쿠키에서 설정 복원
function loadFromCookie() {
  const savedSettings = getCookieObject<{
    mini_sidebar?: boolean;
    setHorizontalLayout?: boolean;
    setRTLLayout?: boolean;
    actTheme?: string;
    inputBg?: string;
    boxed?: boolean;
    setBorderCard?: boolean;
  }>(CUSTOMIZER_COOKIE_KEY);

  if (savedSettings) {
    return {
      ...config,
      ...savedSettings
    };
  }
  return config;
}

// 쿠키에 설정 저장
function saveToCookie(settings: {
  mini_sidebar: boolean;
  setHorizontalLayout: boolean;
  setRTLLayout: boolean;
  actTheme: string;
  inputBg: string;
  boxed: boolean;
  setBorderCard: boolean;
}) {
  setCookieObject(CUSTOMIZER_COOKIE_KEY, {
    mini_sidebar: settings.mini_sidebar,
    setHorizontalLayout: settings.setHorizontalLayout,
    setRTLLayout: settings.setRTLLayout,
    actTheme: settings.actTheme,
    inputBg: settings.inputBg,
    boxed: settings.boxed,
    setBorderCard: settings.setBorderCard
  });
}

// 쿠키에서 로드한 설정
const cookieConfig = loadFromCookie();

export const useCustomizerStore = defineStore("customizer",{

  state: () => ({
    Sidebar_drawer: cookieConfig.Sidebar_drawer,
    Customizer_drawer: cookieConfig.Customizer_drawer,
    mini_sidebar: cookieConfig.mini_sidebar,
    setHorizontalLayout: cookieConfig.setHorizontalLayout, // Horizontal layout
    setRTLLayout: cookieConfig.setRTLLayout, // RTL layout
    actTheme: cookieConfig.actTheme,
    inputBg: cookieConfig.inputBg,
    boxed: cookieConfig.boxed,
    setBorderCard: cookieConfig.setBorderCard
  }),

  getters: {},
  actions: {
    SET_SIDEBAR_DRAWER() {
      this.Sidebar_drawer = !this.Sidebar_drawer;
    },
    SET_SIDEBAR_VISIBLE(payload: boolean) {
      this.Sidebar_drawer = payload;
    },
    SET_MINI_SIDEBAR(payload: any) {
      this.mini_sidebar = payload;
      this.saveSettings();
    },
    SET_CUSTOMIZER_DRAWER(payload: any) {
      this.Customizer_drawer = payload;
    },

    SET_LAYOUT(payload: any) {
      this.setHorizontalLayout = payload;
      this.saveSettings();
    },
    SET_THEME(payload: any) {
      this.actTheme = payload;
      this.inputBg = payload; // inputBg도 함께 업데이트
      this.saveSettings();
    },
    SET_CARD_BORDER(payload: any){
      this.setBorderCard = payload;
      this.saveSettings();
    },
    SET_BOXED_LAYOUT(payload: any) {
      this.boxed = payload;
      this.saveSettings();
    },
    SET_RTL_LAYOUT(payload: any) {
      this.setRTLLayout = payload;
      this.saveSettings();
    },
    // 현재 설정을 쿠키에 저장
    saveSettings() {
      saveToCookie({
        mini_sidebar: this.mini_sidebar,
        setHorizontalLayout: this.setHorizontalLayout,
        setRTLLayout: this.setRTLLayout,
        actTheme: this.actTheme,
        inputBg: this.inputBg,
        boxed: this.boxed,
        setBorderCard: this.setBorderCard
      });
    }
  },
});
